import { useTranslation } from 'react-i18next';

import { Drawer } from 'components/shared/index';

import { BasicReportForm } from './BasicReportForm';
import { REPORT_TYPES } from '../type';

type CollectedReportDrawerProps = {
  containerOpen: boolean;
  handleClose: () => void;
  forcedDefaultReportType?: REPORT_TYPES;
};

const CollectedReportDrawer = ({
  containerOpen,
  handleClose,
  forcedDefaultReportType
}: CollectedReportDrawerProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });

  return (
    <Drawer
      open={containerOpen}
      onClose={handleClose}
      title={t('generateReport')}
      anchor="right"
      PaperProps={{
        sx: {
          width: {
            compact: '100%',
            medium: '70%',
            expanded: '50%',
            large: '35%',
            extralarge: '30%'
          }
        }
      }}
    >
      <BasicReportForm
        handleClose={handleClose}
        forcedDefaultReportType={forcedDefaultReportType}
      />
    </Drawer>
  );
};

export default CollectedReportDrawer;
